<template>
  <div class="asd-form-section">
    <div class="section-title">
      <h5>
        <i class="fas fa-bell"></i>
        Notifikace pro skupiny stavů
      </h5>
      <div class="section-title-controls">
        <ActiveButton class="asd-btn-confirm asd-btn-single-icon"
                      :click="save"
        >
          <i class="fas fa-save"></i>
        </ActiveButton>
      </div>
    </div>
    <table class="asd-table">
      <thead>
        <tr class="table-heading">
          <th>Skupina stavu</th>
          <th>Nastavení</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="sg in stateGroups"
            :key="sg.id"
        >
          <td>
            <i class="fas"
               :class="[sg.icon]"
               :style="{'color': sg.color}"
            ></i>
            {{ sg.label }}
          </td>
          <td>
            <NotificationsEditor :value="notifications[sg.id]"
                                 @input="onEditorInput($event, sg.id)"
            ></NotificationsEditor>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { get } from 'lodash'
import ActiveButton from 'CORE/components/form/active-button'
import stateGroups from 'ENUMS/entity-states-groups'
import NotificationsEditor from './notifications-editor'
import ensurePath from 'CORE/utils/ensure-path'

export default {
    name: 'GroupNotifications',
    components: {
        ActiveButton,
        NotificationsEditor,
    },
    props: {

    },
    data: function() {
        return {
            notifications: {},
        }
    },
    computed: {
        stateGroups() {
            return stateGroups
        },
    },
    mounted() {
        this.notifications = get(this.$store.getters.settings, 'group-notifications', {})
    },
    methods: {
        onEditorInput(e, id) {
            this.$set(this.notifications, id, e)
        },
        async save() {
            const data = this.$store.getters.settings
            ensurePath(data, ['group-notifications/Object'])
            data['group-notifications'] = this.notifications
            try {
                await this.$store.dispatch('saveCurrentUserCompanySettings', data)
                this.flash('Uloženo', 'success', {
                    timeout: 1500,
                })
                this.$emit('done')
            } catch (e) {
                this.flash(`Nepovedlo se [${e.message}]`, 'error')
                throw e
            }
        },
    },
}
</script>

<style lang="scss" scoped>

</style>
